module.exports = __webpack_public_path__ + "img/mask.a5e09db8.png";